import { c as _c } from "react/compiler-runtime";
import React from 'react';
import BrowserOnly from 'components/consumer/BrowserOnly';
import TabletAndDesktopOnly from 'components/consumer/TabletAndDesktopOnly';
import ProductListingColorFilter from '../ProductListingColorFilter';
const DesktopProductListingColorFilter = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <BrowserOnly><TabletAndDesktopOnly><div className="hidden md:block"><ProductListingColorFilter /></div></TabletAndDesktopOnly></BrowserOnly>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default DesktopProductListingColorFilter;